const DEFAULT_CONFIG = {
	//接口地址
	API_URL: 'https://server.zgz.org.cn/api',
}

export default DEFAULT_CONFIG
